export default "__VITE_ASSET__bc5b20ac__"